import * as angular from 'angular';
import 'angular-route';
import 'angular-elastic';
import 'angular-cookies';
import 'angular-sanitize';
import 'ui-select';
import 'angular-file-upload';
import 'angular-aria';
import 'ngGeolocation/ngGeolocation';
import 'ngmap';
import 'angular-ui-mask';
import './controllers';
import './services';
import './filters';
import './directives';
import {setupBugTracking, setUserContext} from 'configurations/bugTracking';
import {setupCacheBuster} from 'configurations/cacheBuster';
import {setupFirsthandAnimate} from 'configurations/firsthandAnimate';

setupBugTracking();
setupCacheBuster();
setupFirsthandAnimate();

export const app = angular.module('app', [
    'ngRoute',
    'ngRaven',
    'monospaced.elastic',
    'ngSanitize',
    'ngAria',
    'ngCookies',
    'cacheBuster',
    'angularFileUpload',
    'ngGeolocation',
    'ngMap',
    'ui.mask',
    'ui.select',
    'firsthandAnimate',
    'app.services',
    'app.controllers',
    'app.directives',
    'app.filters',
]);

// this will control our FullPageLoading
app.run([
    '$rootScope', '$timeout', 'VisitorService', '$cookies', 'fileUploaderOptions',
    function($rootScope, $timeout, VisitorService, $cookies, fileUploaderOptions) {
        $rootScope.isLoading = true;
        $rootScope.hideLoading = false;
        $rootScope.loadingError = null;

        try {
            $rootScope.$on('controllerLoaded', function() {
                $timeout(function() {
                    $rootScope.isLoading = false;

                    $timeout(function() {
                        if ($rootScope.hideLoading) {
                            return;
                        }
                        $rootScope.hideLoading = true;
                        if (window.registrationLoadFinished) {
                            window.registrationLoadFinished();
                        }
                        $rootScope.$apply();
                    }, 1000);
                }, 1000);
            });
        }
        catch (exception) {
            $rootScope.loadingError = 'Oh no! Something went wrong. Please refresh or try contacting us!';
        }

        var xsrfToken = $cookies.get('XSRF-TOKEN');
        if (xsrfToken) {
            fileUploaderOptions.headers['X-XSRF-TOKEN'] = xsrfToken;
            $.ajaxSetup({
                headers: {'X-XSRF-TOKEN': xsrfToken},
            });
        }

        VisitorService.getVisitor().then(function(v) {
            if (v.user && v.user.id) {
                setUserContext({
                    id: v.user.id,
                });
            }
        });
    },
]);

app.config([
    '$routeProvider',
    'uiMaskConfigProvider',
    '$sceDelegateProvider',
    function($routeProvider, uiMaskConfigProvider, $sceDelegateProvider) {
        $routeProvider.when('/', { // --- DEFAULT ---
            templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/controllers/registration.html',
            controller: 'RegistrationController',
        }).when('/matching', {
            templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/controllers/matching.html',
            controller: 'MatchingController',
        }).when('/book/:expertid/:serviceid', {
            templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/controllers/book.html',
            controller: 'BookController',
        }).when('/:group', {
            templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/controllers/registration.html',
            controller: 'RegistrationController',
        }).when('/:group/:step', {
            templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/controllers/registration.html',
            controller: 'RegistrationController',
        }).when('/:group/:step/:sub_step', {
            templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/controllers/registration.html',
            controller: 'RegistrationController',
        }).otherwise({redirectTo: '/'}); // --- END ---

        uiMaskConfigProvider.addDefaultPlaceholder = false;

        var resourceUrlWhitelist = [
            'self',
        ];
        if (Evisors.config.cdnUrl) {
            resourceUrlWhitelist.push(Evisors.config.cdnUrl + '**');
        }
        $sceDelegateProvider.resourceUrlWhitelist(resourceUrlWhitelist);

    },
]);

if ($) {
    // Handle sitewide alert.
    $('.sitewide-alert .hide-this').click(function() {
        $(this).parent('.sitewide-alert').slideUp();
    });
}
